import * as React from 'react';
import Grid from '@mui/material/Grid';
import { useField } from 'formik';
import Checkbox from '../Checkbox';

export default function CheckboxSingleComponent({ label, name }) {
  const [field] = useField({ name });
  return (
    <Grid
      container
      spacing={1}
      justifyContent="flex-start"
      alignItems="flex-start"
    >
      <Grid item xs={12} sm={3}>
        <Checkbox
          // id={x.value}
          {...field}
          // value={x.value}
          checked={field && field.value}
          label={label}
        />
      </Grid>
    </Grid>
  );
}
